// Static Shani transit data — update when Saturn changes sign
// Saturn entered Aquarius (Kumbh) Jan 2023; moves to Pisces (Meen) ~Nov 2025
export const SATURN_TRANSIT = {
  currentRashi: "Aquarius",
  currentRashiHi: "कुंभ (Kumbh)",
  entryDate: "January 17, 2023",
  exitDate: "March 2025 (retrograde back to Aquarius)",
  nextRashi: "Pisces",
  nextRashiHi: "मीन (Meen)",
  nextEntryDate: "March 29, 2025",
  finalEntryDate: "November 2025 (final, stays until 2028)",
};

export interface RashiStatus {
  id: string;
  nameEn: string;
  nameHi: string;
  status: "rising" | "peak" | "setting" | "none";
  phase: string;
  period: string;
}

export const RASHI_STATUS: RashiStatus[] = [
  {
    id: "mesh",
    nameEn: "Aries",
    nameHi: "मेष",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2027–2034",
  },
  {
    id: "vrishabh",
    nameEn: "Taurus",
    nameHi: "वृषभ",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2030–2037",
  },
  {
    id: "mithun",
    nameEn: "Gemini",
    nameHi: "मिथुन",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2032–2040",
  },
  {
    id: "kark",
    nameEn: "Cancer",
    nameHi: "कर्क",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2035–2042",
  },
  {
    id: "singh",
    nameEn: "Leo",
    nameHi: "सिंह",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2037–2044",
  },
  {
    id: "kanya",
    nameEn: "Virgo",
    nameHi: "कन्या",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2039–2047",
  },
  {
    id: "tula",
    nameEn: "Libra",
    nameHi: "तुला",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2041–2049",
  },
  {
    id: "vrishchik",
    nameEn: "Scorpio",
    nameHi: "वृश्चिक",
    status: "none",
    phase: "Not Active",
    period: "Next: ~2044–2051",
  },
  {
    id: "dhanu",
    nameEn: "Sagittarius",
    nameHi: "धनु",
    status: "none",
    phase: "Recently Ended",
    period: "2017–2025 (ended)",
  },
  {
    id: "makar",
    nameEn: "Capricorn",
    nameHi: "मकर",
    status: "rising",
    phase: "Rising Phase",
    period: "2020–2028",
  },
  {
    id: "kumbh",
    nameEn: "Aquarius",
    nameHi: "कुंभ",
    status: "peak",
    phase: "Peak Phase",
    period: "2023–2030",
  },
  {
    id: "meen",
    nameEn: "Pisces",
    nameHi: "मीन",
    status: "setting",
    phase: "Setting Phase",
    period: "2025–2032",
  },
];

export const STATUS_COLORS: Record<
  string,
  { bg: string; border: string; text: string; badge: string; badgeBg: string }
> = {
  rising: {
    bg: "rgba(234,179,8,0.06)",
    border: "rgba(234,179,8,0.3)",
    text: "var(--color-warning-text-dark)",
    badge: "var(--color-warning-text)",
    badgeBg: "rgba(234,179,8,0.15)",
  },
  peak: {
    bg: "rgba(220,38,38,0.06)",
    border: "rgba(220,38,38,0.3)",
    text: "var(--color-error-text)",
    badge: "var(--color-error-text-dark)",
    badgeBg: "rgba(220,38,38,0.12)",
  },
  setting: {
    bg: "rgba(249,115,22,0.06)",
    border: "rgba(249,115,22,0.3)",
    text: "var(--color-warning-orange-dark)",
    badge: "var(--color-warning-orange-dark)",
    badgeBg: "rgba(249,115,22,0.12)",
  },
  none: {
    bg: "rgba(0,0,0,0.02)",
    border: "var(--ish-border-light)",
    text: "var(--ish-text-muted)",
    badge: "var(--ish-text-faint)",
    badgeBg: "rgba(0,0,0,0.04)",
  },
};

export const TRANSIT_TIMELINE = [
  { date: "Jan 24, 2020", event: "Saturn enters Capricorn (Makar)", active: false },
  {
    date: "Jan 17, 2023",
    event: "Saturn enters Aquarius (Kumbh) — Sade Sati begins for Kumbh",
    active: false,
  },
  {
    date: "Mar 29, 2025",
    event: "Saturn enters Pisces (Meen) — Sade Sati begins for Meen",
    active: true,
  },
  { date: "Nov 2025", event: "Saturn final entry into Pisces (after retrograde)", active: true },
  {
    date: "Apr 2028",
    event: "Saturn enters Aries (Mesh) — Sade Sati begins for Mesh",
    active: false,
  },
];

export function todayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
